import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataService } from 'src/app/_service/data.service';

@Component({
  selector: 'app-appt-completion-modal',
  templateUrl: './appt-completion.modal.html',
  styleUrls: ['./appt-completion.modal.scss']
})
export class ApptCompletionModalComponent {
  userPassword: string = '';

  user: any = {};

  constructor(
    private dialogRef: MatDialogRef<ApptCompletionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { apptCount: number },
    private dataService: DataService
  ) {
    this.loadUser();
  }

  loadUser() {
    this.dataService.get('admin-users/self').then((res: any) => {
      if (res && res.user) {
        this.user = res.user;
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onContinue(): void {
    if(!this.userPassword || this.userPassword.trim() === '') return;
    this.dialogRef.close(this.userPassword);
  }
}
